import React, { useEffect } from "react";
import "../../Product/Scheduling/scheduling.css";

export default function Toast({ open, type = "info", message, onClose }) {
  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => onClose?.(), 3200);
    return () => clearTimeout(t);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className={`sched-toast ${type}`} role="status" aria-live="polite">
      <span>{message}</span>
      <button
        className="sched-toast-x"
        onClick={onClose}
        aria-label="Close toast"
      >
        ×
      </button>
    </div>
  );
}
